module.exports = __webpack_public_path__ + "static/images/loginlogo.fc11f3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loginlogo.png
// module id = bVAf
// module chunks = 0